/**
 * Build Phosphor icon CSS class string.
 *
 * @param {string} name Icon name.
 * @param {string} type Icon type (regular, bold, fill, etc.).
 * @return {string} CSS class string or empty string.
 */
export function getIconClass( name, type ) {
	if ( ! name ) {
		return '';
	}
	return `ph${ type !== 'regular' ? '-' + type : '' } ph-${ name }`;
}
